<div fxFlex fxLayout="column" fxLayoutAlign="start stretch">
  @for (channel of channels; track channel) {
    <div
      class="channels-list"
      fxFlex="none"
      fxLayout="row"
      fxLayoutAlign="start center"
      role="listitem"
      [ngClass]="!channel.is_active ? 'inactive' : ''"
      [ngClass]="haveSettings(channel) ? 'have-settings' : ''"
    >
      <app-provider-icon
        fxFlex="none"
        mat-list-avatar
        [provider]="channel.provider"
      ></app-provider-icon>
      <div
        fxFlex
        fxLayout="row"
        fxLayoutAlign="start center"
        (click)="handleClick(channel)"
      >
        <div fxFlex="none" class="channel-name">
          {{ channel.is_playground ? playgroundPrefix : '' }}{{ channel.name }}
        </div>
        @if (channel.whatsapp_calls_enabled) {
          <i
            class="calls-enabled-icon fa-solid fa-phone"
            tooltip="WhatsApp calls enabled"
          ></i>
        }
        @if (channel.channelUrl) {
          <a
            class="provider-link"
            fxFlex="none"
            fxLayout="row"
            fxLayoutAlign="start center"
            href="{{ channel.channelUrl }}"
            target="_blank"
            ><span>{{ channel.channelUrl }}</span
            ><mat-icon>exit_to_app</mat-icon></a
          >
        }
        @if (!channel.is_active) {
          <i
            class="inactive-alert-icon fa-solid fa-circle-exclamation"
            tooltip="This integration is inactive"
          ></i>
        }
      </div>
      <button fxFlex="none" mat-icon-button [matMenuTriggerFor]="menu">
        <mat-icon>more_vert</mat-icon>
      </button>
      <mat-menu #menu="matMenu">
        <!-- TODO: add "see credentials" -->
        @if (channel.is_active && channel.isFacebook) {
          <button mat-menu-item (click)="disableGetStarted(channel)">
            {{ disableGetStartedLabel }}
          </button>
        }
        @if (!channel.is_active && channel.isFacebook) {
          <button mat-menu-item (click)="enableGetStarted(channel)">
            {{ enableGetStartedLabel }}
          </button>
        }
        @if (haveSettings(channel)) {
          <button mat-menu-item (click)="handleClick(channel)">
            {{ showSettingsLabel }}
          </button>
        }
        <button
          mat-menu-item
          (click)="channelDeleted.emit(channel)"
          [matTooltip]="removeLabel"
        >
          {{ removeLabel }}<mat-icon>clear</mat-icon>
        </button>
      </mat-menu>
    </div>
  }
  @if (feedback) {
    <div class="text-feedback">{{ feedback }}</div>
  }
</div>
